import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { isOpenDialogAction, setIsOpenDialogAction } from "../../store/feautures/DialogActionSlice";

export default function ActionConfirm({onAction, title, message, labelConfirm, index, onClose }: any) {

    const isOpen = useSelector(isOpenDialogAction);
    const dispatch = useDispatch();

    const handleClose = () => {
        dispatch(setIsOpenDialogAction({isOpen: false}));
        onClose && onClose();
    }

    return (
        <Transition appear show={isOpen} as={Fragment}>
            <Dialog as="div" className="relative z-50" onClose={() => null}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-black bg-opacity-25" />
                </Transition.Child>

                <div className="fixed inset-0 overflow-y-auto">
                    <div className="flex min-h-full items-center justify-center p-4 text-center">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 scale-95"
                            enterTo="opacity-100 scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 scale-100"
                            leaveTo="opacity-0 scale-95"
                        >
                            <Dialog.Panel className="relative w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                                <Dialog.Title
                                    as="h3"
                                    className="text-lg font-medium leading-6 text-gray-900"
                                >
                                    {title}
                                </Dialog.Title>
                                <div className="text-md text-gray-500 my-4">
                                    {message}
                                </div>

                                <div className="mt-4 grid grid-cols-2 space-x-4">
                                    <button onClick={handleClose} type="button" className="h-10 border !text-[#064e3b] !border-[#064e3b] text-white px-2 inline rounded-lg text-md">
                                        Annulla
                                    </button>
                                    <button onClick={() => { onAction(); handleClose(); }} type="button" className="h-10 bg-[#064e3b] text-white px-2 inline rounded-lg text-md">
                                        {labelConfirm}
                                    </button>
                                </div>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition>
    )
}